import React, { FC, useMemo } from 'react';
import styled, { css } from 'styled-components';
import { CleanButton } from 'src/common/components/Button';
import { colors } from 'src/config/colors';
import { media } from 'src/config/breakpoints';
import { SpeakerInfo } from 'src/common/components/SpeakerInfo';
import { speakerFullName } from 'src/common/services/speaker';
import { getSpeakersItemPageRoute } from 'src/speakers/routes';
import Link from 'next/link';
import { SpeakerDTO } from 'src/common/models/speaker';

const Text = styled.div`
  grid-area: text;
  margin-top: 0.75rem;
  white-space: pre-line;

  ${media.w.min.px768(css`
    font-size: 0.625rem;
    line-height: 0.875rem;
  `)};
`;

const TextButton = styled(CleanButton)`
  color: ${colors.pfp3bis};
  display: inline-block;
  font-size: 0.75rem;
  line-height: 1rem;
  margin-left: auto;
  margin-top: 0.5rem;
  text-decoration-line: underline;
`;

const TextContainer = styled.div`
  display: grid;
  grid-template-areas:
    'text'
    'button';

  ${media.w.min.px768(css`
    display: block;
  `)};
`;

export const CourseSpeaker: FC<{ speaker: SpeakerDTO }> = ({ speaker }) => {
  const bio = useMemo(() => (speaker ? speaker.bio.substring(0, 500) : ''), [speaker]);

  return (
    <div>
      <SpeakerInfo
        avatarImg={speaker?.photo}
        speakerName={speakerFullName(speaker)}
        speakerCompany={speaker.company}
        linkTo={getSpeakersItemPageRoute(String(speaker.id))}
      />
      <TextContainer>
        <Text>{bio}</Text>
        <Link href={getSpeakersItemPageRoute(String(speaker.id))} passHref>
          <TextButton as="a">Czytaj więcej</TextButton>
        </Link>
      </TextContainer>
    </div>
  );
};
